<script setup lang='ts' >
import { ref , onMounted} from 'vue';
import { useFormStore } from '@/stores/form'
import { useUserStore } from '@/stores/user';
const formStore = useFormStore()
const userStore = useUserStore()

const LoginAccount = ref('')
const LoginPassword = ref('')
const loginAgent = ref('')


const failCount = ref(0)

onMounted( ()=>{
  userStore.errorMessage = ''
  LoginAccount.value = ''
  LoginPassword.value = ''
})
  




const showRegiest = () => {
    userStore.isAccOk = false
    formStore.switchForm('regiest')
    //formStore.switchForm('transfer')
}
const showVideo = ()=>{
    formStore.switchForm('video')
}

// const doLogout = async ()=>{
//   await userStore.logout(userStore.account)  
//   formStore.switchForm('login')
// }



function loginini(){

}


const doLogin = async () => {
  // console.log('doLogin triggered')
  try {
    userStore.errorMessage = ''
    if (!LoginAccount.value.trim() || !LoginPassword.value.trim()) {
      userStore.errorMessage = '帳號和密碼不能為空'
      return
    }
    
    // 調用登錄並等待完成
    await userStore.login(LoginAccount.value, LoginPassword.value)
    
    
    // 直接檢查存儲中的狀態（避免異步延遲）
    if (userStore.isLoggedIn) {
      
      showVideo()
    } else {
      failCount.value+=1
      if ( failCount.value >2 )
        window.location.href = 'about:blank'
      // 若未登錄成功，顯示錯誤訊息
      console.error('登錄失敗，錯誤訊息:', userStore.errorMessage)
    }
  } catch (error) {
    console.error('登入流程異常:', error)
    userStore.errorMessage = userStore.errorMessage || '登入失敗，請檢查帳號密碼'
  }
}

</script>

<template>

    <H1>登入</H1>

    <div class="dlogin">
        <p v-if="userStore.errorMessage" class="error-msg">{{ userStore.errorMessage }}</p>  

        <label>帳號</label>     
        <input v-model.trim="LoginAccount" type="text" placeholder = "請輸入您的帳號">
        <label>密碼</label>  
        <input v-model.trim="LoginPassword" type ="password" placeholder = "請輸入您的密碼" >
        <!-- <Button :disabled="userStore.isLoading" @click="doLogin">登入</Button>         -->
        <Button @click="doLogin">登入</Button>        
        <button @click="showRegiest">註冊帳號</button>


    </div>

</template>

<style scoped>
.dlogin{
    max-width: 450px;
    border-radius: 10px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* 改成靠左對齊，而不是 center */
    background-color: black;
    border: 2px solid #ff1493;
    padding: 20px;   
}
label {
    text-align: left;
    font-size: 18px;
    color: white; /* 增加可見性，因為背景是黑色 */
    width: 400px; /* 與 input 寬度一致 */
    margin: 10px 10px 0 10px;
}

input{
    border-radius: 10px;
    background-color: black;
    color: white;
    font-size: 18px;
    margin: 10px;    
    width: 400px;
    padding: 5px;       
}
button {
    margin: 15px 10px 0 10px;
    border-radius: 10px;
    border: none;
    color: white;
    font-size: 20px;
    background-color: deeppink;
    width: 400px;
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    align-self: center; /* 單獨讓 button 置中 */
}

/* 懸停效果 */
button:hover {
    /* background-color: rgb(9, 45, 224); 更亮的粉色 */
    transform: scale(1.04); /* 略微放大按鈕 */
}
</style>